/**
 * Parses a coordinates string (e.g. "55.9011, 21.8568" or "55.9011,21.8568").
 * Expects "lat, lng" format (same as formToCoordinates in route formData).
 * Returns [lng, lat] for Mapbox, or null if parsing fails.
 */
const parseCoordinates = (coordinatesString) => {
  if (coordinatesString == null || typeof coordinatesString !== 'string') {
    return null;
  }
  const trimmed = coordinatesString.trim();
  if (!trimmed) return null;

  // Allow optional whitespace around comma: "lat, lng" or "lat,lng"
  const match = /^([+-]?\d+(?:[.,]\d+)?)\s*,\s*([+-]?\d+(?:[.,]\d+)?)$/.exec(
    trimmed
  );
  if (!match) {
    return null;
  }
  const parseNum = (s) => parseFloat(s.replace(',', '.'), 10);
  const first = parseNum(match[1]);
  const second = parseNum(match[2]);
  if (Number.isNaN(first) || Number.isNaN(second)) {
    return null;
  }
  // Stored format is "lat, lng" -> return [lng, lat] for Mapbox
  return [second, first];
};

export default parseCoordinates;
